import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
declare var $: any;
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { DepositorDetailsService } from 'src/app/services/depositor-details.service';
import { AlertComponent } from 'src/app/structure/alert/alert.component';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-depositor-list',
  templateUrl: './depositor-list.component.html',
  styleUrls: ['./depositor-list.component.css']
})
export class DepositorListComponent implements OnInit {

  public environmentSettings: any;

  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;
  dtOptionsOfMasterDirector: DataTables.Settings = {};
  dtOptionsOfRegisterDirector: DataTables.Settings = {};
  registerMgt2List: any[];
  masterDirectorList: any[];
  FromDateModelInMasterDirector: any;
  ToDateModelInMasterDirector: any;
  dtTriggerMasterDirector: Subject<any> = new Subject();
  dtTriggerRegisterDirector: Subject<any> = new Subject();
  error: any = { isError: false, errorMessage: '' };
  futureToDate: NgbDateStruct;
  futureFromDate: NgbDateStruct;
  response: boolean;
  dtTriggerRegister: Subject<any> = new Subject();
  depositDetailList: any[];
  nameOfDepositor: any;
  deleteDepositId: any;
  editRegulatroy: any;
  dateOfRepayable: any;
  dateOfDeposit: any;
  isSearchDivVisible = false;

  constructor(private router: Router, private alert: AlertComponent,
     private depositorDetailsService: DepositorDetailsService,private activatedRoute: ActivatedRoute) {
    this.response = false;
  }
  toggleSearchDiv() {
    this.isSearchDivVisible = !this.isSearchDivVisible;
  }

  add(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['depositordetails','add']  } }],
      { relativeTo: this.activatedRoute.parent });
  }
  ngOnInit() {
    this.environmentSettings = environment;
    this.getDepositDetailList();

    this.dtOptionsOfRegisterDirector = {
      destroy: true,
      scrollY: "210px",
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [6] }],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Depositor Details',
          title: 'Depositor Details',
          extend: 'excel',
          exportOptions: {
            columns: [0, 1, 2, 3, 4, 5],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
          }
        }
      ]
    };
  }

  getDepositDetailList() {
    this.depositDetailList = [];
    $("#depositorlistTable").DataTable().destroy();
    this.depositorDetailsService.getDepositorlistDetail({ isSearch: false })
      .subscribe(depositList => {
        console.log("depositList.data", depositList.data)
        console.log("director.depositDetails;",  depositList.data[0]['depositDetails']);
        this.depositDetailList = depositList.data;
        this.dtTriggerRegister.next();
      });
  }

  confirmDelete(id) {
    this.deleteDepositId = id;
    $("#deleteConfirm").modal('toggle');
  }

  deleteDepositor() {
    this.depositorDetailsService.removeDepositor(this.deleteDepositId)
      .subscribe(response => {
        if (response.status == 0) {
          this.alert.success(response.message);
          $("#depositorlistTable").DataTable().destroy();
          $('#deleteConfirm').modal('toggle');
        } else {
          this.alert.error(response.message);
        }
        this.getDepositDetailList();

      });
  }

  editDepositor(_id) {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['depositordetails','edit',_id]  } }],
      { relativeTo: this.activatedRoute.parent });
    // this.router.navigate(['depositordetails/edit/', _id]);
  }
  generateOutput() {
    let companyId = JSON.parse(localStorage.getItem('companyDetails')).companyID;
    var object = {
      id: null,
      fromDate: null,
      toDate: null,
      name: this.nameOfDepositor
    }
    this.depositorDetailsService.generateDepositorDetailsDocument(object).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadDocument(companyId);
          setTimeout(function () {
            self.downloadPdfDocument(companyId);
          }, 1000);
        }, 1000);
      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadDocument(id) {
    this.depositorDetailsService.downloadDepositorDetailsFile(id, 'Multi');
  }
  downloadPdfDocument(id) {
    this.depositorDetailsService.downloadDepositorDetailsPdfFile(id, 'Multi');
  }
  setDate(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }
  doAdvSearch() {
    this.response = true;
    var searchParam = {
      'nameOfDepositor': this.nameOfDepositor,
      'dateOfRepayable':this.setDate(this.dateOfRepayable),
      'dateOfDeposit':this.setDate(this.dateOfDeposit),
      'isSearch': true,
    };
    this.depositDetailList = [];
    $("#depositorlistTable").DataTable().destroy();
    this.depositorDetailsService.getDepositorlistDetail(searchParam).subscribe(registerList => {
      this.response = false;
      if (registerList.status == 0) {
        this.depositDetailList = registerList.data;
        this.dtTriggerRegister.next();
      }
    });
  }
  clearAdvSearch() {
    this.nameOfDepositor = undefined;
    this.dateOfRepayable='';
    this.dateOfDeposit='';
    $("#depositorlistTable").DataTable().destroy();
    this.getDepositDetailList();
  }
}

